<template>
  <div>
    <viewTable
        ref="viewTable"
        :limits="limits"
        :columns-property="columnsProperty"
        :filter="filter"
        module="basic"
        url="purchaseOrders"
        :table-select="false"
        @delete="deleteHandle"
        @reset="resetHandle"
        @addOrEdit="addEditHandle">
      <template slot="otherBtn">
        <el-button v-if="limits.saleAuth" type="primary" @click="$refs.salePurchaseOrderEdit.open()"> 销售采购</el-button>
        <el-button v-if="limits.supAuth" type="primary" @click="$refs.supPurchaseOrderEdit.open()"> 供应商采购</el-button>
      </template>
      <template slot="adSearch">
        <el-form :inline="true" :model="filter" label-width="90px" @keyup.enter.native="loadData(1)">
          <el-form-item label="采购单号">
            <el-input v-model.trim="filter.purchaseOrderNo" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="供应商编号">
            <el-input v-model.trim="filter.supplierNo" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="供应商名称">
            <el-input v-model.trim="filter.supplierName" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="物料编号">
            <el-input v-model.trim="filter.materialNo" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="物料名称">
            <el-input v-model.trim="filter.materialName" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="规格型号">
            <el-input v-model.trim="filter.specification" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="制单日期">
            <el-date-picker
                v-model="createDateRange"
                type="daterange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                value-format="yyyy-MM-dd"
                @change="dateRangeChange('createDateRange', 'createDateBegin', 'createDateEnd')"/>
          </el-form-item>
          <el-form-item label="要求交期">
            <el-date-picker
                v-model="deliveryDateRange"
                type="daterange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                value-format="yyyy-MM-dd"
                @change="dateRangeChange('deliveryDateRange', 'deliveryDateBegin', 'deliveryDateEnd')"/>
          </el-form-item>
          <el-form-item label="送货状态">
            <el-select v-model="bindingStatusReceive" multiple clearable @change="handleSelectReceive">
              <el-option label="未送货" :value="0"/>
              <el-option label="部分送货" :value="10"/>
              <el-option label="全部送货" :value="20"/>
            </el-select>
          </el-form-item>
          <el-form-item label="收货状态">
            <el-select v-model="bindingStatusArrive" multiple clearable @change="handleSelectArrive">
              <el-option label="未收货" :value="0"/>
              <el-option label="部分收货" :value="10"/>
              <el-option label="全部收货" :value="20"/>
            </el-select>
          </el-form-item>
          <el-form-item label="入库状态">
            <el-select v-model="bindingStatusStock" multiple clearable @change="handleSelectStock">
              <el-option label="未入库" :value="0"/>
              <el-option label="部分入库" :value="10"/>
              <el-option label="全部入库" :value="20"/>
            </el-select>
          </el-form-item>
          <el-form-item label="包含附件">
            <el-select v-model="filter.attachment" clearable>
              <el-option label="是" :value="1"/>
              <el-option label="否" :value="0"/>
            </el-select>
          </el-form-item>
          <el-form-item label="特殊标识">
            <el-select v-model="filter.specialFlag" clearable>
              <el-option label="是" :value="1"/>
              <el-option label="否" :value="0"/>
            </el-select>
          </el-form-item>
          <el-form-item label="制单人">
            <el-input type="textarea" v-model="filter.creatorName" placeholder="请输入" clearable/>
          </el-form-item>
        </el-form>
      </template>
      <template slot="actionBtn" slot-scope="scope">
        <el-button v-if="limits.updateDateAuth" type="primary" @click="updateDate(scope.row)">维护交期</el-button>
        <upload-file
            v-if="limits.uploadAuth"
            ref="upload"
            style="display: inline-block;margin: 0 5px"
            :show-file-list="false"
            :loading="uploadLoading"
            :auth-index="authIndex"
            @upload-success="uploadSuccess($event,scope.row)"/>
        <el-button
            v-if="limits.submitAuth"
            :disabled="scope.row.status !== 10"
            type="primary"
            @click="submitRow(scope.row)">
          提交
        </el-button
        >
        <el-button v-if="limits.importAuth" type="primary" @click="exportPurchaseOrderExcel(scope.row)">导出</el-button>
      </template>
    </viewTable>
    <order-final-delivery ref="deliverySelect"/>
    <sale-purchase-order-edit ref="salePurchaseOrderEdit" @save-success="loadData"/>
    <sup-purchase-order-edit ref="supPurchaseOrderEdit" @save-success="loadData"/>
  </div>
</template>

<script>
  import viewTable from "@/components/ViewTable.vue";
  import SalePurchaseOrderEdit from "./SalePurchaseOrderEdit.vue";
  import SupPurchaseOrderEdit from "./SupPurchaseOrderEdit.vue";
  import UploadFile from "@/components/UploadFile";
  import OrderFinalDelivery from "@/views/StoreManagement/PurchaseOrder/OrderFinalDeliveryHead";

  export default {
    name: "PurchaseOrderList",
    components: {viewTable, SalePurchaseOrderEdit, SupPurchaseOrderEdit, UploadFile, OrderFinalDelivery},
    data() {
      return {
        limits: {
          saleAuth: this.$auth(702),
          supAuth: this.$auth(705),
          editAuth: this.$auth(703),
          delAuth: this.$auth(704),
          importAuth: this.$auth(708),
          submitAuth: this.$auth(709),
          updateDateAuth: this.$auth(429),
          uploadAuth: this.$auth(710),
        },
        authIndex: 710,
        uploadLoading: false,
        createDateRange: [],
        deliveryDateRange: [],
        bindingStatusReceive: [],
        bindingStatusArrive: [],
        bindingStatusStock: [],
        filter: {
          purchaseOrderNo: "",
          supplierNo: "",
          supplierName: "",
          materialNo: "",
          materialName: "",
          deliveryDateBegin: "",
          deliveryDateEnd: "",
          createDateBegin: "",
          createDateEnd: "",
          specification: "",
          status: -1,
          poReceiveStatusStr: "",
          poArriveStatusStr: "",
          poStockStatusStr: "",
          poReceiveStatus: -1,
          attachment: "",
          creatorName: "",
          specialFlag: "",
          pageSize: 20,
        },
        columnsProperty: [
          {
            width: 55,
            align: "center",
            type: "expand",
            fixed: "left",
            render: (h, params) => {
              return h("Table", {
                props: {
                  data: params.row.detailVOS,
                  columns: [
                    {
                      type: "index",
                      width: 55,
                      align: "center",
                    },
                    {
                      title: "物料编号",
                      key: "materialNo",
                      width: 150,
                    },
                    {
                      title: "物料名称",
                      key: "materialName",
                      minWidth: 150,
                    },
                    {
                      title: "规格型号",
                      key: "specification",
                      minWidth: 150,
                    },
                    {
                      title: "单位",
                      key: "measuringUnitName",
                      width: 70,
                      align: "center",
                    },
                    {
                      title: "数量",
                      key: "qty",
                      width: 80,
                      align: "center",
                    },
                    {
                      title: "送货单数量",
                      key: "sendedQuantity",
                      width: 105,
                      align: "center",
                    },
                    {
                      title: "收货数量",
                      key: "hasArriveQty",
                      width: 90,
                      align: "center",
                    },
                    {
                      title: "入库数量",
                      key: "hasInstockQty",
                      width: 90,
                      align: "center",
                    },
                    {
                      title: "单价",
                      key: "unitPrice",
                      width: 80,
                      render: (h, params) => {
                        return h("span", params.row.unitPrice == null ? "***" : params.row.unitPrice);
                      },
                      align: "center",
                    },
                    {
                      title: "总价",
                      key: "price",
                      width: 80,
                      render: (h, params) => {
                        return h("span", params.row.price == null ? "***" : params.row.price);
                      },
                      align: "center",
                    },
                    {
                      title: "要求交期",
                      key: "deliveryDate",
                      width: 110,
                      align: "center",
                    },
                    {
                      title: "最终交期",
                      key: "finalDeliveryDate",
                      width: 110,
                      align: "center",
                    },
                    {
                      title: "销售订单",
                      key: "salesOrderNo",
                      width: 150,
                      align: "center",
                    },
                    {
                      title: "合同号",
                      key: "customerContractNo",
                      width: 150,
                      align: "center",
                    },
                  ],
                  border: true,
                  stripe: true,
                },
              });
            },
          },
          {
            key: "purchaseOrderNo",
            align: "center",
            width: 150,
            render: (h, params) => {
              return h(
                  "span",
                  {
                    style: {
                      color: params.row.attachmentCount === 0 ? "" : "#2d8cf0",
                      cursor: "pointer",
                    },
                    on: {
                      click: () => {
                        if (params.row.salesOrderNo) {
                          this.$refs.salePurchaseOrderEdit.open(params.row, true, 1);
                        } else {
                          this.$refs.supPurchaseOrderEdit.open(params.row, true, 1);
                        }
                      },
                    },
                  },
                  params.row.purchaseOrderNo,
              );
            },
          },
          {
            key: "specialFlag",
            align: "center",
            width: 120,
            render: (h, params) => {
              return h(
                  "span",
                  {
                    class: params.row.specialFlag === 1 ? "el-icon-s-flag" : "",
                  },
                  // params.row.specialFlag,
              );
            },
          },
          {
            key: "action",
            align: "center",
            fixed: "right",
            width: 210,
            slot: "action",
          },
        ],
      };
    },

    watch: {
      "filter.createDateBegin": {
        handler(newVal) {
          if (newVal) {
            this.createDateRange = [];
            this.createDateRange.push(this.filter.createDateBegin);
            this.createDateRange.push(this.filter.createDateEnd);
          }
        },
      },
      "filter.deliveryDateBegin": {
        handler(newVal) {
          if (newVal) {
            this.deliveryDateRange = [];
            this.deliveryDateRange.push(this.filter.deliveryDateBegin);
            this.deliveryDateRange.push(this.filter.deliveryDateEnd);
          }
        },
      },
      "filter.poReceiveStatusStr": {
        handler(val) {
          if (val) {
            this.bindingStatusReceive = [];
            val.split(",").forEach((s) => {
              this.bindingStatusReceive.push(parseInt(s));
            });
          }
        },
      },
      "filter.poArriveStatusStr": {
        handler(val) {
          if (val) {
            this.bindingStatusArrive = [];
            val.split(",").forEach((s) => {
              this.bindingStatusArrive.push(parseInt(s));
            });
          }
        },
      },
      "filter.poStockStatusStr": {
        handler(val) {
          if (val) {
            this.bindingStatusStock = [];
            val.split(",").forEach((s) => {
              this.bindingStatusStock.push(parseInt(s));
            });
          }
        },
      },
    },

    methods: {
      // 查询采购单列表
      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },
      handleSelectReceive(value) {
        if (value.length) {
          this.bindingStatusReceive = value;
          this.filter.poReceiveStatusStr = value.join(",");
        } else {
          this.bindingStatusReceive = [];
          this.filter.poReceiveStatusStr = "";
        }
      },
      handleSelectArrive(value) {
        if (value.length) {
          this.bindingStatusArrive = value;
          this.filter.poArriveStatusStr = value.join(",");
        } else {
          this.bindingStatusArrive = [];
          this.filter.poArriveStatusStr = "";
        }
      },
      handleSelectStock(value) {
        if (value.length) {
          this.bindingStatusStock = value;
          this.filter.poStockStatusStr = value.join(",");
        } else {
          this.bindingStatusStock = [];
          this.filter.poStockStatusStr = "";
        }
      },
      addEditHandle(row) {
        this.$refs.supPurchaseOrderEdit.open(row);
      },

      // 删除
      deleteHandle(row) {
        this.$http.delete("basic", "purchaseOrders", row.pkid).then((resp) => {
          if (resp.success) {
            this.loadData();
            this.$message.success("删除成功");
          }
        });
      },

      submitRow(row) {
        this.$confirm("确定提交吗?", "提示", {type: "warning"}).then(() => {
          this.$http
              .get("basic", `purchaseOrders/submit/${row.pkid}`)
              .then((res) => {
                if (res.success) {
                  this.$message.success("提交成功");
                  this.loadData();
                }
              })
              .catch(() => {
              });
        });
      },

      dateRangeChange(timeRange, timeStart, timeEnd) {
        if (this[timeRange]) {
          this.filter[timeStart] = this[timeRange][0];
          this.filter[timeEnd] = this[timeRange][1];
        } else {
          this.filter[timeStart] = "";
          this.filter[timeEnd] = "";
        }
      },

      updateDate(row) {
        console.log(row);
        this.$refs.deliverySelect.open(row.pkid);
        this.loadData(1);
      },

      // 上传文件
      uploadSuccess(fileList, row) {
        if (fileList.length) {
          this.uploadLoading = true;
          const params = {
            itemType: 40,
            fileName: fileList[0].name,
            filePath: fileList[0].key,
            itemID: row.pkid,
          };
          this.$http.post("basic", "purchaseOrders/attachment", params)
              .then((res) => {
                if (res.success) {
                  this.$message.success("上传成功");
                  this.loadData(1);
                }
                this.uploadLoading = false;
              })
              .catch(() => {
                this.uploadLoading = false;
              });
        }
      },

      // 导出
      exportPurchaseOrderExcel(row) {
        this.$http.exportFile("basic", `purchaseOrders/exportPurchaseOrderExcel/${row.pkid}`).then((res) => {
          let blob = new Blob([res.data]);
          let fileName = decodeURI(res.headers.filename);
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, fileName);
          } else {
            let a = document.createElement("a");
            a.href = URL.createObjectURL(blob);
            a.download = "采购单" + row.purchaseOrderNo + ".xlsx";
            a.style.display = "none";
            document.body.appendChild(a);
            a.click();
            URL.revokeObjectURL(a.href);
            document.body.removeChild(a);
          }
        });
      },

      // 重置
      resetHandle(filter) {
        this.filter = Object.assign(this.filter, filter);
        this.date = "";
      },

      otherAuth(row) {
        if (row.status === 20) {
          return {
            editAuth: true,
            delAuth: true,
          };
        } else {
          return {
            editAuth: false,
            delAuth: false,
          };
        }
      },
    },
  };
</script>
